<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Settings</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active"> Site Settings
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4 class="card-title">Site Information</h4>
                </div>
                <div class="card-body">
                    <form novalidate @submit.prevent="updateSetting">
                        <validation-errors></validation-errors>
                        <div class="row">
                            <div class="col-6 mb-3">
                                <label for="site_name" class="form-label">Site Name</label>
                                <input type="text" id="site_name" class="form-control" v-model="setting.site_title">
                            </div>

                            <div class="col-6 mb-3">
                                <label for="email" class="form-label">Email</label>
                                <input type="email" id="email" placeholder="e.g admin@keru.com"
                                       class="form-control" v-model="setting.email">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <label for="phone" class="form-label">Phone No</label>
                                        <input type="number" id="phone" placeholder="e.g 09234723994"
                                               class="form-control" v-model="setting.phone">
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label for="frontend_url" class="form-label">Website Url</label>
                                        <input type="text" id="frontend_url" placeholder="e.g https://keru.com"
                                               class="form-control" v-model="setting.website_url">
                                    </div>
                                </div>
                            </div>

                            <div class="col-6 mb-3">
                                <label for="meta_title" class="form-label">
                                    Address
                                </label>
                                <textarea id="address" cols="30" rows="2" class="form-control"></textarea>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 mb-3">
                                <label class="form-label">Site Description</label>
                                <vue-editor v-model="setting.site_description"></vue-editor>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-xs-12">
                                <button class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {VueEditor} from "vue2-editor";
import ValidationErrors from "../../Shared/ValidationErrors";

export default {
    metaInfo: {title: 'Create Admin'},
    name: 'AdminCreate',
    props: ['settingsData'],
    components: {
        VueEditor,
        ValidationErrors
    },
    layout: Layout,
    data() {
        return {
            saving: false,
            setting: [],
        }
    },
    methods: {
        async updateSetting() {
            this.saving = true;
            this.$inertia.put(route('admin.settings.update'), {...this.setting}, {
                preserveScroll: true,
                onSuccess: () => this.saving = false,
                onError: () => {
                    this.saving = false;
                }
            });
        }
    },
    mounted() {
        console.log(this.settingsData);
        let data = Object.keys(this.settingsData);
        if (data.length) {
            this.setting.site_title = this.settingsData.site_title
            this.setting.meta_title = this.settingsData.meta_title
            this.setting.meta_description = this.settingsData.meta_description
            this.setting.phone = this.settingsData.phone
            this.setting.address = this.settingsData.address
            this.setting.site_description = this.settingsData.site_description
            this.setting.site_name = this.settingsData.site_name
            this.setting.email = this.settingsData.email
            this.setting.site_name = this.settingsData.site_name
            this.logo = this.settingsData.logo
            this.setting.website_url = this.settingsData.website_url
        }
    },
}
</script>
